import { useState, useEffect } from 'react';
import { WifiIcon } from '@heroicons/react/24/outline';

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setWasOffline(true);
    };

    const handleOnline = () => {
      setIsOffline(false);
      // Show "back online" message briefly
      setTimeout(() => setWasOffline(false), 3000);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline && !wasOffline) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] transition-all duration-300 ${
        isOffline
          ? 'bg-red-600 text-white'
          : 'bg-green-600 text-white'
      }`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium">
        <WifiIcon className="w-4 h-4" aria-hidden="true" />
        {isOffline
          ? 'You are offline. Some features may be unavailable.'
          : 'Back online. Connection restored.'}
      </div>
    </div>
  );
}
